export default __webpack_public_path__ + "static/media/battery.3054835b.png";